import toast from "react-hot-toast";
import { APIEnv, APIResponse } from "../interface/baseInterfaces";
import { DotNetBaseService } from "./base-services/DotNetBaseService";
import { LearningBaseService } from "./base-services/LearningBaseService";
import { NodeBookStoreBaseService } from "./base-services/NodeBookstoreBaseService";
import { NodeDashboardBaseService } from "./base-services/NodeDashboardBaseService";
import { NodeRedisBaseService } from "./base-services/NodeRedisBaseService";
import { PremiumBaseService } from "./base-services/PremiumBaseService";
import { RedisBaseService } from "./base-services/RedisBaseService";
import { TaxPracticeBaseService } from "./base-services/TaxPracticeBaseService";
import { NodeEndmileBaseService } from "./base-services/NodeEndmileBaseService";
import { MarketingBaseService } from "./base-services/MarketingBaseService";
import { NodeDashboardBaseSessionMangementservice } from "./base-services/NodeDashboardSessionManagement";

const ApiService = {
    fetchData(param:any, ENV: APIEnv = APIEnv.NODE_PREMIUM) {

        if (ENV === APIEnv.NODE_PREMIUM) {
            return new Promise<APIResponse>((resolve, reject) => {

                PremiumBaseService(param).then((response: { data: APIResponse | PromiseLike<APIResponse>; }) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    reject(errors)
                })
            })
        }else if (ENV === APIEnv.TAX_PRACTICE) {
            return new Promise<APIResponse>((resolve, reject) => {

                TaxPracticeBaseService(param).then((response: { data: APIResponse | PromiseLike<APIResponse>; }) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    reject(errors)
                })
            })
        }else if (ENV === APIEnv.NODE_BOOKSTORE) {
            return new Promise<APIResponse>((resolve, reject) => {

                NodeBookStoreBaseService(param).then((response: { data: APIResponse | PromiseLike<APIResponse>; }) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    reject(errors)
                })
            })
        }else if (ENV === APIEnv.NODE_DASHBOARD) {
            return new Promise<APIResponse>((resolve, reject) => {

                NodeDashboardBaseService(param).then((response: { data: APIResponse | PromiseLike<APIResponse>; }) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    reject(errors)
                })
            })
        }
        else if (ENV === APIEnv.NODE_REDIS) {
            return new Promise<APIResponse>((resolve, reject) => {

                NodeRedisBaseService(param).then((response: { data: APIResponse | PromiseLike<APIResponse>; }) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    reject(errors)
                })
            })
        }
        else if (ENV === APIEnv.REDIS) {
            return new Promise<APIResponse>((resolve, reject) => {
                RedisBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        reject(errors);
                    });
            });
        }
        else if (ENV === APIEnv.LEARNING) {
            return new Promise<APIResponse>((resolve, reject) => {

                LearningBaseService(param).then((response: { data: APIResponse | PromiseLike<APIResponse>; }) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    reject(errors)
                })
            })
        }
        else if (ENV === APIEnv.DOT_NET) {
            return new Promise<APIResponse>((resolve, reject) => {
                DotNetBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                        if (errors?.code === "ERR_NETWORK") {
                            toast.error(
                                "Unable to connect to server.Please try again later."
                            );
                        }
                        reject(errors);
                    });
            });
        }
        else if (ENV === APIEnv.ENDMILE) {
            return new Promise<APIResponse>((resolve, reject) => {
                NodeEndmileBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        reject(errors);
                    });
            });
        }
        else if (ENV === APIEnv.MARKETING) {
            return new Promise<APIResponse>((resolve, reject) => {
                MarketingBaseService(param)
                    .then((response: any) => {
                        resolve(response?.data);
                    })
                    .catch((errors: any) => {
                        // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                        if (errors?.code === "ERR_NETWORK") {
                            toast.error(
                                "Unable to connect to server.Please try again later."
                            );
                        }
                        reject(errors);
                    });
            });
        }
        else  if (ENV === APIEnv.NODE_DASHBOARD_SESSION_MANAGEMENT) {
            return new Promise<APIResponse>((resolve, reject) => {
                NodeDashboardBaseSessionMangementservice(param).then((response: any ) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                    reject(errors)
                })
            })
        }
    }
}

export default ApiService